import script from "./contact_us.vue?vue&type=script&setup=true&lang=js"
export * from "./contact_us.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__